import React from 'react';

export const Folder: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3333 7.5147V5.95999C13.3333 5.22361 12.7364 4.62666 12 4.62666H8.35276C8.13209 4.62666 7.92571 4.51746 7.80157 4.33501L6.86491 2.9583C6.74077 2.77585 6.53438 2.66665 6.31369 2.66666H3.33333C2.59695 2.66666 2 3.26361 2 3.99999V12.2236C2 12.5179 2.11692 12.8002 2.32505 13.0083C2.53317 13.2164 2.81544 13.3333 3.10977 13.3333V13.3333C3.62992 13.3333 4.08027 12.9721 4.19311 12.4643L5.10133 8.37742C5.2369 7.76737 5.77797 7.33333 6.40289 7.33332H12.6661C13.0706 7.33332 13.4531 7.51688 13.7062 7.83235C13.9592 8.14782 14.0554 8.5611 13.9677 8.9559L13.227 12.2892C13.0914 12.8993 12.5503 13.3333 11.9254 13.3333H3.10977"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
